var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget)return null;return _vm.closeModal.apply(null, arguments)}}},[_c('div',{staticClass:"modal-content"},[_c('button',{staticClass:"close-button",on:{"click":_vm.closeModal}},[_vm._v("×")]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }